/* eslint-disable custom/no-restricted-translation-jsx-untranslated-children-text */
import React from 'react';

import { Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';

import styles from './Content.module.css';

interface ContentStreetLongTermRentalsProps {
  streetName: string;
  cityName: string;
}

export const ContentStreetLongTermRentals = ({
  streetName,
  cityName,
}: ContentStreetLongTermRentalsProps) => {
  const { locale } = useIntl();

  return locale === Locale.en ? (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        {`Long Term Rentals in ${streetName}, ${cityName}`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Looking for long term rentals in ${streetName}? Kamernet makes it simple to
        find a long stay rental in ${streetName} with listings that are updated
        frequently. You’ll discover long term accommodation in ${streetName} for
        students and traveling professionals that suits different needs and
        budgets. Whether you’re interested in long term apartments, long stay
        studios or rooms in ${streetName} for long term, there’s something for
        everyone. Renting long-term housing in ${streetName} gives you more comfort
        and stability during your stay. It’s easy to rent a flat in ${streetName} for
        long term and settle into a space that feels like home.`}
      </Typography>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        {`Lange termijn huren in ${streetName}, ${cityName}`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Op zoek naar lange termijn huren in ${streetName}? Kamernet maakt het
        eenvoudig om een appartement te huur in ${streetName} voor lange termijn te
        vinden. De aanbiedingen worden regelmatig bijgewerkt zodat je altijd
        toegang hebt tot actuele opties. Je vindt gemakkelijk een appartement
        huren in ${streetName} voor lange termijn dat past bij jouw wensen en budget.
        Of je nu student bent of als professional tijdelijk in de stad
        verblijft, er zijn passende mogelijkheden beschikbaar. Een huis huren in
        ${streetName} voor lange termijn geeft je meer comfort en stabiliteit tijdens
        je verblijf. Zo kun je je snel thuis voelen in een vertrouwde omgeving.`}
      </Typography>
    </React.Fragment>
  );
};
